<template>
    <div v-loading="loading" class="myLogin">
        <div class="inner">
            <h2>
                {{ $t('loginMessage') }}
            </h2>
            <div class="myInput">
                <el-input v-on:keyup.enter.native="login()" v-model="email" :placeholder="$t('loginEmail')"></el-input>
            </div>
            <div class="myInput">
                <el-input v-on:keyup.enter.native="login()" v-model="password" :placeholder="$t('loginPassword')"
                    :type="inputType">
                    <i slot="suffix" class="el-input__icon el-icon-view" style="cursor: pointer;" 
                        @click="inputType === 'password' ? inputType = 'text' : inputType = 'password'"
                    />
                </el-input>
            </div>
            <div style="text-align: center" v-if="error">

            <span class="errorMsg">
            {{ $t(errorMessage) }}
            </span>
            </div>
            <div>
                <el-button v-on:click="login()" class="button" type="primary"> {{ $t('loginButton') }} </el-button>
            </div>
            <div style="clear: both; margin: 20px"></div>
            <a @click="passwordReset"> {{ $t('loginForgotPassword') }} </a>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api/api';
    import { success } from './Notification/notification';
    export default {
        props: {
            before: {}
        },
        data() {
            return {
                email: null,
                password: null,
                error: false,
                loading: false,
                errorMessage: '',
                inputType: 'password'
            }
        },
        computed : {
            ...mapGetters({
                user: 'getCurrentUser'
            })  
        },
        methods: {
            success,
            passwordReset () {
                this.$router.push({name: 'PasswordReset'})
            },
            login() {
                if (this.email === null || this.email === '' || this.password === null || this.password === '') {
                    this.showError('loginBlankFieldWarning')
                    return
                }
                this.loading = true
                let res
                let self = this
               
                api.login({
                    email: this.email,
                    password: this.password
                }).then(function (response) {
                    res = response
                    let token = response.data.data.access_token
                    localStorage.setItem('authToken', token)
                    localStorage.setItem('auto', false)
                    self.$store.dispatch('loadAuthToken', token)
                    self.fetchLoggedIn()
                    self.loading = false
                    
                    if (self.before) {
                        if (self.before.name)
                            self.$router.push({name: self.before.name, params: self.before.params})
                        else self.$router.push('/dashboard')
                    } else {
                        self.$router.push('/dashboard')
                    }
                })
                .catch((err) => {
                    self.loading = false
                    self.showError('loginWrongCombinationWarning')
                })
            },
            showError(str) {
                this.errorMessage = str
                this.error = true
                let self = this
                setTimeout(function () {
                    self.error = false
                }, 2000)
            },
            async fetchLoggedIn () {
                await this.$store.dispatch('fetchSelf')
            }
        }
    }
</script>

<style scoped>
    a {
        color: #409EFF;
        font-size: 12px;
        cursor: pointer;
    }
    h2 {
        font-weight: 200;
        padding-bottom: 30px;
    }
    .myLogin {
        background-color: white;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.05);
    }

    .inner {
        padding: 20px;
        text-align: center;
    }

    .myInput {
        margin-bottom: 15px;
        margin-top: 15px;
    }

    .button {
        width: 100%;
    }

    .errorMsg {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue